import { TranslatableText } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';
import { VisitEnterButton } from '~libs.desktop.shared.visit-enter';

import { visitTranslationKeys } from '../../../translations';
import { AccountConfigurationVerificationEventInterceptorConstructor } from '../../appointments.types';

import { useCreateAppointmentOutOfSchedule } from './AppointmentOutOfScheduleButton.hooks';

type AppointmentOutOfScheduleButtonProps = {
   readonly patientId: number;
   readonly compact?: boolean;
   readonly disabled?: boolean;
   readonly accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptorConstructor;
   readonly goBackButtonLabel?: TranslatableText;
};

const AppointmentOutOfScheduleButton = (props: AppointmentOutOfScheduleButtonProps): JSX.Element => {
   const { executeAsync: createAppointmentOutOfSchedule } = useCreateAppointmentOutOfSchedule(props.patientId);
   return (
      <VisitEnterButton
         patientId={props.patientId}
         label={visitTranslationKeys.appointmentOutOfSchedule.label}
         onClick={createAppointmentOutOfSchedule}
         testId='createAppointmentOutOfSchedule'
         accountConfigurationVerificationEventInterceptor={props.accountConfigurationVerificationEventInterceptor}
         compact={props.compact}
         disabled={props.disabled}
         goBackButtonLabel={props.goBackButtonLabel}
      />
   );
};

export const useAppointmentOutOfScheduleButton = (): typeof AppointmentOutOfScheduleButton | null => {
   return protectFeature('searchingVisitOperations', AppointmentOutOfScheduleButton, null);
};
